module.exports = __webpack_public_path__ + "31afe27fab62d2090624fe8f3aeb6deb.svg";